import type { SVGProps } from "react";

export const RouteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M6 21V15C6 14.45 6.19583 13.9792 6.5875 13.5875C6.97917 13.1958 7.45 13 8 13H16V6.8L14.4 8.4L13 7L17 3L21 7L19.6 8.4L18 6.8V13C18 13.55 17.8042 14.0208 17.4125 14.4125C17.0208 14.8042 16.55 15 16 15H8V21H6Z"
      fill="#C9E6FF"
    />
  </svg>
);
